import { MultimediaType } from '../../enums/multimedia-type';

export const isImageType = (type: MultimediaType): boolean => {
  return type === MultimediaType.Image;
};
